import React from "react";
import PropTypes from "prop-types";
import {
  Segment,
  Container,
  Header as SemanticHeader,
} from "semantic-ui-react";

export const Header = ({ inverted, children, ...rest }) => (
  <SemanticHeader
    inverted={inverted}
    style={{ color: inverted ? "white" : "#333" }}
    {...rest}
  >
    {children}
  </SemanticHeader>
);
export const Block = (
  {
    children,
    large,
    small,
    title,
    color,
    style,
    transition,
    narrow,
    visible,
    ...props
  },
  { isMobile }
) => {
  let fontColor = "#000";
  let backgroundColor = "#fff";
  if (color === "gray") {
    backgroundColor = "#f8f8f8";
  }
  if (color === "darkgrey") {
    backgroundColor = "#323232";
  }
  if (color === "yellow") {
    backgroundColor = "#fbbd08";
  }
  if (color === "darkblue") {
    backgroundColor = "#015a9e";
  }
  if (color === "orange") {
    backgroundColor = "#f2711c";
    fontColor = "#fff";
  }
  if (color === "green") {
    backgroundColor = "#1ba555";
    fontColor = "#fff";
  }
  if (color === "newblack") {
    backgroundColor = "#262626";
    fontColor = "#fff";
  }
  if (color === "newblue") {
    backgroundColor = "#015A9E";
    fontColor = "#fff";
  }

  if (color === "skyblue") {
    backgroundColor = "#db2828";
    fontColor = "#fff";
  }

  if (color === "red") {
    backgroundColor = "#db2828";
    fontColor = "#fff";
  }

  let padding = "3em";
  if (large) {
    padding = "4em";
  } else if (small) {
    padding = "1.5em";
  }

  // for adsense, but don't activate yet.
  /*
  if (!visible) {
    return null
  }
  */

  return (
    <Segment
      vertical
      {...props}
      style={{
        padding: isMobile ? "3em 1em" : padding,
        backgroundColor,
        transition: transition
          ? "color 1s ease-out, background-color 1s ease-out"
          : "none",
        ...style,
      }}
    >
      {title && (
        <Header
          as="h1"
          textAlign="center"
          size="huge"
          style={{ marginBottom: "1em", color: fontColor }}
        >
          {title}
        </Header>
      )}
      <Container style={narrow ? { width: 800 } : {}}>{children}</Container>
    </Segment>
  );
};

Block.defaultProps = {
  visible: true,
};

Block.contextTypes = {
  isMobile: PropTypes.bool,
};
